import { render, staticRenderFns } from "./ModalImprimirCertificado.vue?vue&type=template&id=f731b3a2&"
import script from "./ModalImprimirCertificado.vue?vue&type=script&lang=js&"
export * from "./ModalImprimirCertificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports